module.exports = __webpack_public_path__ + "img/img-0dbfc3.png";